import { create } from 'zustand';

import { createNotificationsSlice } from './actions';
import { NotificationsStore } from './types';

export const useNotificationsStore = create<NotificationsStore>()(
  (set, get, store) => ({
    ...createNotificationsSlice(set, get, store),
  }),
);
